import React from 'react'

const SidebarSearch = ({ searchChange, searchString, searchPlaceholder }) => (
    <form
        id="client-search"
        onSubmit={(e) => {
            e.preventDefault()
        }}
    >
        <input
            type="text"
            value={searchString || ''}
            onChange={(event) => {
                const {
                    target: { value },
                } = event
                searchChange(value)
            }}
            placeholder={searchPlaceholder || 'Search Resources'}
        />
    </form>
)

export default SidebarSearch
